<template>
  <base-layout>
    <template v-slot:header>
      <app-header />
    </template>
    <template v-slot:banner>
      <Banner :title="title" />
    </template>
    <template v-slot:default>
      <section>
       <div class="position-relative overflow-hidden text-center">
      <div class="mx-auto my-5">
        <h1 class="display-1">404</h1>
        <h3 class="mb-5">Oops! This Page Could Not Be Found</h3>
        <a class="main_btn" v-on:click="window.analytics.track('VisitHomeFrom404')" href="/">Go to Homepage</a>
      </div>
      <div class="product-device box-shadow d-none d-md-block"></div>
      <div class="product-device product-device-2 box-shadow d-none d-md-block"></div>
    </div>

      </section>
    </template>

    <template v-slot:footer>
      <app-footer />
    </template>
  </base-layout>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'
import BaseLayout from '@/layout/BaseLayout'

export default {
  title: 'Page Not Found',
  components: {
    BaseLayout,
    AppHeader,
    AppFooter
  },
  mounted () {
    window.analytics.page('404')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/404.vue